export default __webpack_public_path__ + "static/media/FSC_updated.c4f5ceba.png";